import {TimelineMax} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Game} from "../Game";
import {IFinalEvaluatedArea} from "../server/Data";
import {GameAssets} from "../GameAssets";
import {MyriadPro} from "../Fonts";
import {Sound} from "../sound/Sound";

export class WaysCounter extends PIXI.Container {
    public symCountInReels: number[] = [3, 2, 3, 2, 3];
    public _stickyFFCounterForFS: number[] = [0, 0, 0, 0, 0];
    private _counter: PIXI.BitmapText;
    private _waysText: PIXI.Text;

    constructor() {
        super();
        this.name = "WaysCounter";
        this.createCounter();

    }

    public updatePossibleWaysCounter(reset: boolean = false, isFinal: boolean = false, isXHole: boolean = false): void {
        if (reset) { // added this code to add sticky ff ways with normal ways
            this.symCountInReels = [3, 2, 3, 2, 3]
            for (let i = 0; i < this.symCountInReels.length; i++) {
                this.symCountInReels[i] += this._stickyFFCounterForFS[i];
            }
        }

        const counter: PIXI.BitmapText = this._counter;
        counter.anchor = new PIXI.Point(0.5, 0.5);
        const from: string = counter.text;
        const to: number = isFinal ? this.getFinalWaysCount(isXHole) : this.symCountInReels.reduce((a: number, b: number) => a * b);
        const duration: number = reset ? 0.0001 : 0.2;

        const tl: TimelineMax = new TimelineMax({
            onStart:()=>{
                if(!reset && (+to > +from)){
                    Game.soundPlayer.stopSound(Sound.WAYS_COUNTER);
                    Game.soundPlayer.avoidFrequentPlaySoundAndPlayLastQueued(Sound.WAYS_COUNTER, Sound.WAYS_COUNTER);
                }
            },
            onUpdate: () => {
                counter.text = Math.round(Number(counter.text)).toString();
                const scale: number = Math.min(120 / (this._counter.textWidth), 1);
                this._counter.scale.set(scale);
            },
            onComplete: () => {
                counter.text = Math.round(to).toString();
                const scale: number = Math.min(120 / (this._counter.textWidth), 1);
                this._counter.scale.set(scale);
                // #92
                if (reset) {
                    this._counter.tint = 0x777777;
                } else {
                    this._counter.tint = 0xbbbbbb;
                }
            }
        });
        // #92
        tl.add(() => {
            if (!reset && counter.text !== (to + "")) {
                this._counter.tint = 0xffffff;
            }
        }, 0);

        tl.fromTo(counter, duration, {text: from}, {text: to + ""});
    }

    public getFinalWaysCount(isXHole: boolean): number {
        const finalEvaluatedArea: IFinalEvaluatedArea[][][] = isXHole ? Game.model.gameData.finalEvaluatedAreaAfterXhole : Game.model.data.finalEvaluatedArea;
        let calcTotalWays: number = 1;
        for (let i: number = 0; i < finalEvaluatedArea.length; i++) {
            let waysPerReel: number = 0;
            const reelEvalArea: IFinalEvaluatedArea[][] = finalEvaluatedArea[i];
            for (let j: number = 0; j < reelEvalArea.length; j++) {
                const allSyms: IFinalEvaluatedArea[] = reelEvalArea[j];
                for (let k: number = 0; k < allSyms.length; k++) {
                    const symObj: IFinalEvaluatedArea = allSyms[k];
                    if (symObj.symTo !== "BLANK") {
                        waysPerReel += symObj.size * symObj.multiplier;
                    }
                }
            }
            calcTotalWays *= waysPerReel;
        }

        Logger.logDev("totalWays:", calcTotalWays);
        return calcTotalWays;
    }

    private createWaysText(fontSize?: number): PIXI.Text {
        const text: PIXI.Text = new PIXI.Text(Game.apiPlugin.translations.translate("Ways"), {
            fontFamily: MyriadPro.FAMILY,
            "dropShadow": true,
            "dropShadowBlur": 5,
            "dropShadowDistance": 2,
            "fill": "#ff6600",
            "fontSize": fontSize || 20,
            "lineJoin": "round",
            "miterLimit": 30,
            "strokeThickness": 4
        });
        text.anchor.set(0.5);
        text.alpha = 0.3; //#405
        return text;
    }

    private createCounter(): void {
        this._counter = new PIXI.BitmapText("000", {
            fontName: GameAssets.BITMAP_FONT_X_NUDGE_WIN_COUNT_UP,
            fontSize: 20,
            align: "center",
            tint: 0x777777,
            maxWidth: 120
        });
        this._counter.alpha = 0.5; //#405
        this._waysText = this.createWaysText();
        this._waysText.position.set(216, 165);
        this.addChild(this._waysText, this._counter)
        this.updatePossibleWaysCounter(true); // as per initial reel set
        this._counter.position.set(214, 185);
    }
}